import { useState } from "react";
import { Box, Grid, Button } from "@mui/material";

import AnnexesUploader from "../generic/AnnexesUploader";

const ContractNewsAttach = ({
  idx,
  contract,
  setNews,
  onSubmit
}) => {
  const [annexes, setAnnexxes] = useState(contract.news[idx]?.annexes || []);

  const handleSubmit = () => {
    const tmpNews = [...contract.news];
    tmpNews[idx] = {
      ...tmpNews[idx],
      annexes
    };
    setNews(tmpNews);
    if (onSubmit) onSubmit();
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AnnexesUploader
            annexes={annexes}
            setAnnexes={setAnnexxes}
          />
        </Grid>

        <Grid item xs={12} sx={{ textAlign: "center", mt: 3 }}>
          <Button
            variant="contained"
            type="button"
            onClick={handleSubmit}
          >
            Añadir adjunto
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContractNewsAttach;
